import { UUID } from "../../../typings/global";
import { CommissionsSettingsRankEnumeration } from "../../enumerations/types";
import { CommissionsSettingsRank, CreateUpdateCommissionsSettingsRank } from "./types";

export const convertCommissionsSettingsRankToCreateUpdateObject = (
  rank: CommissionsSettingsRank,
): CreateUpdateCommissionsSettingsRank => {
  const { createdAt, updatedAt, id, formerRanks, nextRank, ...data } = rank;

  return { ...data, nextRankId: nextRank?.id };
};

export const createCommissionsSettingsRankChain = (
  ranks: CommissionsSettingsRankEnumeration[],
  startRankId: UUID,
): CommissionsSettingsRankEnumeration[] => {
  const rankMap = new Map<UUID, CommissionsSettingsRankEnumeration>();

  ranks.forEach((rank) => {
    rankMap.set(rank.id, rank);
  });

  const result: CommissionsSettingsRankEnumeration[] = [];
  let currentRankId: UUID | undefined = startRankId;

  while (currentRankId) {
    const currentRank = rankMap.get(currentRankId);
    if (!currentRank) {
      break;
    }

    result.push(currentRank);
    currentRankId = currentRank.nextRankId;
  }

  return result;
};
